/**
 *
 * @type {{REJECT: number, DRAFT: number, VENDOR: number, PARTIAL: number, APPROVED: number, PARTIALLY_SHIPPED: number, AWAITING_APPROVAL: number, BILLED: number, WAITING_APPROVAL: number}}
 * @description WAITING_APPROVAL use for approval that must activate on settings
 * NOT SAVE AS DRAFT
 */
const statusConst = {
  DRAFT: 11,
  AWAITING_APPROVAL: 12,
  APPROVED: 13,
  BILLED: 14,
  VENDOR: 1,
  PARTIAL: 6,
  PARTIALLY_SHIPPED: 15,
  WAITING_APPROVAL: 111,
  REJECT: 112,
}

const statusColors = [
  { id: statusConst.AWAITING_APPROVAL, color: '#EB9234' },
  { id: statusConst.DRAFT, color: '#13A4FF' },
  { id: statusConst.APPROVED, color: '#00CBCD' },
  { id: statusConst.BILLED, color: '#11A428' },
  { id: statusConst.PARTIALLY_SHIPPED, color: '#EB9234' },
  { id: statusConst.WAITING_APPROVAL, name: 'Waiting Approval', color: '#13A4FF' },
  { id: statusConst.REJECT, name: 'Reject', color: '#CF2A28' },
]

export { statusConst, statusColors }
